var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var PACKING_PERF_EVENT_NAME = 'packing:perf';
var DEFAULT_FULL_REFRESH_DEBOUNCE_MS = 1200;
var scheduledFullRefreshByShipmentId = new Map();
var shouldLogPackingPerf = function () {
    if (typeof window === 'undefined')
        return false;
    try {
        return window.localStorage.getItem('packingPerfDebug') === '1';
    }
    catch (_a) {
        return false;
    }
};
var getThunkActionStatus = function (action) {
    if (typeof (action === null || action === void 0 ? void 0 : action.type) !== 'string')
        return 'unknown';
    if (action.type.endsWith('/fulfilled'))
        return 'fulfilled';
    if (action.type.endsWith('/rejected'))
        return 'rejected';
    return 'unknown';
};
export var nowMs = function () {
    return typeof performance !== 'undefined' && typeof performance.now === 'function'
        ? performance.now()
        : Date.now();
};
// Emits a browser event for timeline instrumentation and optional console debugging.
export var emitPackingPerf = function (event, details) {
    if (details === void 0) { details = {}; }
    var payload = __assign({ event: event, ts: Date.now() }, details);
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
        try {
            window.dispatchEvent(new CustomEvent(PACKING_PERF_EVENT_NAME, { detail: payload }));
        }
        catch (_a) {
            // no-op
        }
    }
    if (shouldLogPackingPerf()) {
        console.info("[" + PACKING_PERF_EVENT_NAME + "] " + event, payload);
    }
};
export var extractErrorMessage = function (error, fallback) { var _a, _b, _c, _d; return ((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors) || ((_d = (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) || fallback; };
export var getShipmentPayloadStats = function (data) {
    var _a, _b, _c, _d, _e;
    return ({
        shipmentItemCount: ((_a = data === null || data === void 0 ? void 0 : data.shipmentItemDetailList) === null || _a === void 0 ? void 0 : _a.length) || 0,
        shipmentSourceItemCount: ((_b = data === null || data === void 0 ? void 0 : data.shipmentItemSourceList) === null || _b === void 0 ? void 0 : _b.length) || 0,
        shipmentPackageCount: ((_c = data === null || data === void 0 ? void 0 : data.shipmentPackageList) === null || _c === void 0 ? void 0 : _c.length) || 0,
        shipmentProductIndexCount: ((_d = data === null || data === void 0 ? void 0 : data.shipmentProductSkuUpcViewList) === null || _d === void 0 ? void 0 : _d.length) || 0,
        packageRouteSegmentCount: ((_e = data === null || data === void 0 ? void 0 : data.packageRouteSegList) === null || _e === void 0 ? void 0 : _e.length) || 0
    });
};
// Coalesces repeated refresh requests for the same shipment into one delayed refresh.
export var scheduleDebouncedFullShipmentRefresh = function (_a) {
    var shipmentId = _a.shipmentId, reason = _a.reason, performRefresh = _a.performRefresh, _b = _a.debounceMs, debounceMs = _b === void 0 ? DEFAULT_FULL_REFRESH_DEBOUNCE_MS : _b;
    if (!shipmentId)
        return;
    var existingTimer = scheduledFullRefreshByShipmentId.get(shipmentId);
    if (existingTimer) {
        clearTimeout(existingTimer);
    }
    var timer = setTimeout(function () {
        scheduledFullRefreshByShipmentId.delete(shipmentId);
        var refreshStartedAt = nowMs();
        emitPackingPerf('shipment_full_refresh.started', { shipmentId: shipmentId, reason: reason });
        void performRefresh()
            .then(function (action) {
            emitPackingPerf('shipment_full_refresh.completed', {
                shipmentId: shipmentId,
                reason: reason,
                durationMs: Number((nowMs() - refreshStartedAt).toFixed(1)),
                status: getThunkActionStatus(action)
            });
        })
            .catch(function (error) {
            emitPackingPerf('shipment_full_refresh.failed', {
                shipmentId: shipmentId,
                reason: reason,
                durationMs: Number((nowMs() - refreshStartedAt).toFixed(1)),
                error: extractErrorMessage(error, 'Failed to refresh shipment')
            });
        });
    }, debounceMs);
    scheduledFullRefreshByShipmentId.set(shipmentId, timer);
    emitPackingPerf('shipment_full_refresh.scheduled', {
        shipmentId: shipmentId,
        reason: reason,
        debounceMs: debounceMs
    });
};
// Runs immediate lightweight refresh, then schedules eventual full consistency refresh.
export var runFastMutationRefresh = function (_a) {
    var shipmentId = _a.shipmentId, mutation = _a.mutation, performFastRefresh = _a.performFastRefresh, scheduleFollowUpRefresh = _a.scheduleFollowUpRefresh;
    return __awaiter(void 0, void 0, void 0, function () {
        var refreshStartedAt, _b, packagesResult, itemAssetsResult, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    refreshStartedAt = nowMs();
                    emitPackingPerf('shipment_fast_refresh.started', { shipmentId: shipmentId, mutation: mutation });
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, performFastRefresh()];
                case 2:
                    _b = _c.sent(), packagesResult = _b.packagesResult, itemAssetsResult = _b.itemAssetsResult;
                    emitPackingPerf('shipment_fast_refresh.completed', {
                        shipmentId: shipmentId,
                        mutation: mutation,
                        durationMs: Number((nowMs() - refreshStartedAt).toFixed(1)),
                        packagesStatus: getThunkActionStatus(packagesResult),
                        itemAssetsStatus: getThunkActionStatus(itemAssetsResult)
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _c.sent();
                    emitPackingPerf('shipment_fast_refresh.failed', {
                        shipmentId: shipmentId,
                        mutation: mutation,
                        durationMs: Number((nowMs() - refreshStartedAt).toFixed(1)),
                        error: extractErrorMessage(error_1, 'Failed fast refresh')
                    });
                    return [3 /*break*/, 4];
                case 4:
                    scheduleFollowUpRefresh();
                    return [2 /*return*/];
            }
        });
    });
};
